import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step16 from './Step16-redux';

export default compose(
  withRouter,
  withNextStep
)(Step16);
